const AGGS_CARD_SIZE_KEY =
  'card:landscape:grid--four:image-right__border-rounded popular-categories';
const AGGS_CARDS_WRAPPER =
  'grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 grid--one';

const DEFUALT_SORT = { property: 'name', direction: 'asc' };

export { AGGS_CARD_SIZE_KEY, AGGS_CARDS_WRAPPER, DEFUALT_SORT };
